module.exports = __webpack_public_path__ + "static/media/down-chevron.1adfeb5f.svg";